export function loadImageProcess(src: string) {
  return new Promise<HTMLImageElement>((resolve, reject) => {
    let img = new Image()
    img.onload = () => resolve(img)
    img.onerror = reject
    img.src = src
  })
}
export function loadImageProcessToCanvas(file: File) {
  return new Promise<HTMLCanvasElement>((resolve, reject) => {
    const url = URL.createObjectURL(file)
    const img = new Image()
    img.src = url
    img.onerror = reject
    const canvas = document.createElement('canvas')
    img.onload = () => {
      canvas.width = 360
      canvas.height = (360 * img.height) / img.width
      const ctx = canvas.getContext('2d')
      if (!ctx) return
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
      resolve(canvas)
    }
  })
}
export function loadCanvasToCanvas90Deg(cv: HTMLCanvasElement) {
  return new Promise<HTMLCanvasElement>((resolve, reject) => {
    const img = new Image()
    img.src = cv.toDataURL()
    img.onerror = reject
    const canvas = document.createElement('canvas')
    img.onload = () => {
      canvas.width = img.height
      canvas.height = img.width
      const ctx = canvas.getContext('2d')
      if (!ctx) return
      ctx.save()
      ctx.translate(canvas.width / 2, canvas.height / 2)
      ctx.rotate(Math.PI / 2)
      ctx.drawImage(img, -img.width / 2, -img.height / 2)
      ctx.rotate(-Math.PI / 2)
      ctx.translate(-canvas.width / 2, -canvas.height / 2)
      ctx.restore()
      resolve(canvas)
    }
  })
}
export function loadCanvasToCanvasMinus90Deg(cv: HTMLCanvasElement) {
  return new Promise<HTMLCanvasElement>((resolve, reject) => {
    const img = new Image()
    img.src = cv.toDataURL()
    img.onerror = reject
    const canvas = document.createElement('canvas')
    img.onload = () => {
      canvas.width = img.height
      canvas.height = img.width
      const ctx = canvas.getContext('2d')
      if (!ctx) return
      ctx.save()
      ctx.translate(canvas.width / 2, canvas.height / 2)
      ctx.rotate(-Math.PI / 2)
      ctx.drawImage(img, -img.width / 2, -img.height / 2)
      ctx.rotate(Math.PI / 2)
      ctx.translate(-canvas.width / 2, -canvas.height / 2)
      ctx.restore()
      resolve(canvas)
    }
  })
}
export function loadCanvasAndResize(canvas: HTMLCanvasElement) {
  return new Promise<HTMLCanvasElement>((resolve, reject) => {
    const img = new Image()
    img.src = canvas.toDataURL()
    img.onerror = reject
    img.onload = () => {
      canvas.width = 360
      canvas.height = 360 * (img.height / img.width)
      var ctx = canvas.getContext('2d')
      if (ctx) {
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
        resolve(canvas)
      }
    }
  })
}
